<template>
  <vue-editor v-model="value" />
</template>

<script>
import { fieldMixin } from '../../../mixins/fieldMixin'
import { VueEditor } from 'vue2-editor'

export default {
  mixins: [fieldMixin],
  components: {
    VueEditor
  }
}
</script>

<style lang="scss">
  .ql-toolbar.ql-snow {
    overflow: auto;
  }
</style>
